// Mirrors mealz-api's ClientLogRequest EVENT_PATTERN and its 100-character cap.
const EVENT_PATTERN = /^(?:[a-z][a-z0-9_]*|[A-Za-z][A-Za-z0-9]*\.[A-Za-z][A-Za-z0-9_]*)$/u
const MAX_EVENT_LENGTH = 100

export const isValidClientLogEvent = (event: string): boolean =>
  event.length <= MAX_EVENT_LENGTH && EVENT_PATTERN.test(event)
